import { createFileRoute } from "@tanstack/react-router";
import { ExecutionHostsView } from "@/components/views/hosts/ExecutionHostsView";

export const Route = createFileRoute("/hosts")({
  component: ExecutionHostsView,
});
